import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../constants';

const HORIZONTAL_CM = 7;
const VERTICAL_CM = 5;

const useStyles = makeStyles(() => ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    triangle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
        backgroundImage: `linear-gradient(135deg, ${COLORS.primaryD1 + '66'}, ${COLORS.primaryD1 + '22'})`,
    },
    triangleBorder: {
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    horizontalEdge: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '1px',
        backgroundColor: '#555',
    },
    verticalEdge: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '1px',
        height: '100%',
        backgroundColor: '#555',
    },
    rightAngleIndicator: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '6%',
        height: '8.5%',
        border: '1px solid #555',
        borderBottom: 'none',
        borderLeft: 'none',
    },
    hCm: {
        position: 'absolute',
        bottom: 0,
        borderLeft: '1px solid #555',
        height: '16px',
    },
    hMm: {
        position: 'absolute',
        bottom: 0,
        borderLeft: '1px solid #555',
        height: '10px',
    },
    hLabel: {
        position: 'absolute',
        bottom: '16px',
        font: '11px/1 sans-serif',
        color: '#555',
    },
    vCm: {
        position: 'absolute',
        left: 0,
        borderTop: '1px solid #555',
        width: '16px',
    },
    vMm: {
        position: 'absolute',
        left: 0,
        borderTop: '1px solid #555',
        width: '10px',
    },
    vLabel: {
        position: 'absolute',
        left: '16px',
        font: '11px/1 sans-serif',
        color: '#555',
    },
}));

export default function TrySquareDIV() {
    const classes = useStyles();

    let hMarks = [];
    for (let i = 0; i <= HORIZONTAL_CM; i++) {
        let pct = (i * 100) / HORIZONTAL_CM;
        hMarks.push(
            <div key={`h-cm-${i}`}>
                <div className={classes.hCm} style={{ left: pct + '%' }} />
                {i < HORIZONTAL_CM && <span className={classes.hLabel} style={{ left: `calc(${pct}% + 2px)` }}>{i}</span>}
                {i < HORIZONTAL_CM &&
                    Array.from({ length: 9 }, (_, j) => (
                        <div
                            className={classes.hMm}
                            key={`h-mm-${i}-${j}`}
                            style={{ left: ((i * 10 + j + 1) * 100) / (HORIZONTAL_CM * 10) + '%', height: j === 4 ? '14px' : undefined }}
                        />
                    ))}
            </div>
        );
    }

    let vMarks = [];
    for (let i = 0; i <= VERTICAL_CM; i++) {
        let pct = 100 - (i * 100) / VERTICAL_CM;
        vMarks.push(
            <div key={`v-cm-${i}`}>
                <div className={classes.vCm} style={{ top: pct + '%' }} />
                {i < VERTICAL_CM && <span className={classes.vLabel} style={{ top: `calc(${pct}% + 2px)` }}>{i}</span>}
                {i < VERTICAL_CM &&
                    Array.from({ length: 9 }, (_, j) => (
                        <div
                            className={classes.vMm}
                            key={`v-mm-${i}-${j}`}
                            style={{ top: 100 - ((i * 10 + j + 1) * 100) / (VERTICAL_CM * 10) + '%', width: j === 4 ? '14px' : undefined }}
                        />
                    ))}
            </div>
        );
    }

    return (
        <div className={classes.container}>
            <div className={classes.triangle} />
            <svg
                style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0 }}
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
            >
                <line x1="0" y1="0" x2="100" y2="100" stroke="#555" strokeWidth="0.3" />
            </svg>
            <div className={classes.horizontalEdge} />
            <div className={classes.verticalEdge} />
            <div className={classes.rightAngleIndicator} />
            {hMarks}
            {vMarks}
        </div>
    );
}
